module.exports = __webpack_public_path__ + "static/media/rectangleshapeIcon.c7cb8a86.png";